import bootstrapIcon from './bootstrapIcon';
import richmediaIcon from './richmediaIcon';
import sublimeIcon from './sublimeIcon';

export default {
  bootstrapIcon,
  sublimeIcon,
  richmediaIcon,
};
